import { render, staticRenderFns } from "./pos.vue?vue&type=template&id=6a4d1a5c&"
import script from "./pos.vue?vue&type=script&lang=js&"
export * from "./pos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports